"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAmountRange = exports.getSalesRange = exports.getTargetSales = exports.getSalarySystemSetting = exports.hasAllStoresAccess = exports.reverseCurrencyFormat = exports.currencyFormat = exports.numberFormat = exports.getIdForDisplay = exports.getOrderPaymentAmount = exports.getOrderItemRecord = exports.calculateOrder = exports.getAdminType = void 0;
var __1 = require("..");
var graphql_1 = require("../__generated__/graphql");
var constants_1 = require("../constants");
/** 管理者タイプの取得 */
var getAdminType = function (admin) {
    if (admin.isMaster) {
        // 総合管理者
        return graphql_1.AdminType.MASTER;
    }
    else if (admin.isCollector) {
        // 集金担当者
        return graphql_1.AdminType.COLLECTOR;
    }
    else {
        // 店舗管理者
        return graphql_1.AdminType.ADMIN;
    }
};
exports.getAdminType = getAdminType;
/**
 * 会計の計算ロジック
 */
var calculateOrder = function (orderItems, course, storeServiceFee, storeStaffReservationFee, initialPrice, initialCount, optionalAmount, orderHostId, // Orderに紐付くhostId, 指名料の有無判定に使う
amountRoundingMethod) {
    // デフォルト値
    storeServiceFee = storeServiceFee !== null && storeServiceFee !== void 0 ? storeServiceFee : constants_1.DEFAULT_STORE_VALUES.serviceFee;
    storeStaffReservationFee = storeStaffReservationFee !== null && storeStaffReservationFee !== void 0 ? storeStaffReservationFee : constants_1.DEFAULT_STORE_VALUES.staffReservationFee;
    initialPrice = initialPrice !== null && initialPrice !== void 0 ? initialPrice : constants_1.DEFAULT_INITIAL_VALUES.price;
    initialCount = initialCount !== null && initialCount !== void 0 ? initialCount : constants_1.DEFAULT_INITIAL_VALUES.count;
    amountRoundingMethod = amountRoundingMethod !== null && amountRoundingMethod !== void 0 ? amountRoundingMethod : constants_1.DEFAULT_STORE_VALUES.amountRoundingMethod;
    // 小計
    var subtotal = orderItems.reduce(function (accumulator, currentValue) {
        return accumulator + currentValue.price * currentValue.quantity;
    }, 0);
    // サービス料(店舗毎に設定されたパーセンテージを掛ける)
    var serviceFee = course === graphql_1.OrderCourse.FIRST_TIME ? 0 : (subtotal * storeServiceFee) / 100;
    // 消費税
    var tax = course === graphql_1.OrderCourse.FIRST_TIME ? 0 : (subtotal + serviceFee) * constants_1.CONSUMPTION_TAX;
    // 初回料金
    var initialFee = course === graphql_1.OrderCourse.FIRST_TIME ? initialPrice * initialCount : 0;
    // 指名料(税金処理とか全て終わった後、最後に付く)
    var staffReservationFee = (function () {
        // 1時間制(延長なし)は固定で指名料0
        if (course === graphql_1.OrderCourse.ONE_HOUR_NO_EXTENSION) {
            return 0;
        }
        // それ以外のケースはホストと紐付く場合は全て指名料あり
        return orderHostId ? storeStaffReservationFee : 0;
    })();
    var total = subtotal + serviceFee + tax + staffReservationFee + initialFee;
    var totalRounded = (function () {
        // 端数処理で場合分け
        if (amountRoundingMethod === graphql_1.RoundingMethod.CEIL) {
            // 切り上げを選択している店舗は切り上げにする
            return Math.ceil(total / 1000) * 1000;
        }
        else if (amountRoundingMethod === graphql_1.RoundingMethod.FLOOR) {
            // 現状切り捨ての指定はないけど、念のため分けておく
            return Math.floor(total / 1000) * 1000;
        }
        else {
            // デフォルトは四捨五入
            // 1000円単位未満を四捨五入
            return Math.round(total / 1000) * 1000;
        }
    })();
    var taxRounded = Math.floor(tax); // 表示のため切り捨て
    var serviceFeeRounded = Math.floor(serviceFee); // 表示のため切り捨て
    // 表示上の帳尻を合わせるために、切り捨て後の値を使って算出
    var adjustment = totalRounded - subtotal - serviceFeeRounded - taxRounded - staffReservationFee - initialFee;
    return {
        subtotal: subtotal,
        adjustment: adjustment,
        tax: taxRounded,
        serviceFee: serviceFeeRounded,
        total: totalRounded + (isNaN(optionalAmount) ? 0 : optionalAmount),
        staffReservationFee: staffReservationFee,
        initialPrice: initialPrice,
        initialCount: initialCount,
    };
};
exports.calculateOrder = calculateOrder;
var getOrderItemRecord = function (orderItem) {
    var _a, _b;
    var id = orderItem.id, item = orderItem.item, quantity = orderItem.quantity, status = orderItem.status, pageIndex = orderItem.pageIndex, isUsedForLastsong = orderItem.isUsedForLastsong, isKitchenChecked = orderItem.isKitchenChecked;
    var itemId = item.id, host = item.host;
    // 履歴からの情報があればそれを使う
    var itemName = (_a = orderItem.itemName) !== null && _a !== void 0 ? _a : item.name;
    var itemPrice = (_b = orderItem.itemPrice) !== null && _b !== void 0 ? _b : item.price;
    return {
        id: id,
        itemId: itemId,
        name: itemName === constants_1.ITEM_HOST_NAME ? "".concat(itemName, " ").concat(host === null || host === void 0 ? void 0 : host.name) : itemName,
        quantity: quantity,
        status: status,
        pageIndex: pageIndex !== null && pageIndex !== void 0 ? pageIndex : 0,
        isUsedForLastsong: isUsedForLastsong,
        isKitchenChecked: isKitchenChecked,
        total: quantity * itemPrice,
        price: itemPrice,
        category: item.category,
    };
};
exports.getOrderItemRecord = getOrderItemRecord;
/** 会計額の取得 */
var getOrderPaymentAmount = function (orderPayment) {
    if (!orderPayment) {
        return 0;
    }
    return ((orderPayment.cash || 0) +
        (orderPayment.creditCard || 0) +
        (orderPayment.accountReceivable || 0) +
        (orderPayment.tipping || 0));
};
exports.getOrderPaymentAmount = getOrderPaymentAmount;
/** 表示用IDの取得 */
var getIdForDisplay = function (rawId) {
    if (!rawId) {
        return "";
    }
    // 実際のIDの最初の方だけ
    return rawId.split("-")[0];
};
exports.getIdForDisplay = getIdForDisplay;
/** 数値 → 10,000 への変換 (3桁コンマ区切り) */
var numberFormat = function (number) {
    if (number === null || number === undefined) {
        return "";
    }
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
exports.numberFormat = numberFormat;
/** 数値 → ¥10,000 への変換 (円マーク+3桁コンマ区切り) */
var currencyFormat = function (number) {
    if (number === null || number === undefined) {
        return "";
    }
    return "\u00A5".concat((0, exports.numberFormat)(number));
};
exports.currencyFormat = currencyFormat;
/** ¥10,000 → 数値 への変換 */
var reverseCurrencyFormat = function (str) {
    if (str === null || str === undefined) {
        return 0;
    }
    return Number(str.replace("¥", "").replace(/,/g, ""));
};
exports.reverseCurrencyFormat = reverseCurrencyFormat;
/** 全店舗検索へのアクセス可否 */
var hasAllStoresAccess = function (isMaster) {
    // 総合管理者以外は不可
    if (!isMaster) {
        return false;
    }
    // 営業時間帯を禁止する
    return !(0, __1.isBetweenHours)("1900", "0030");
};
exports.hasAllStoresAccess = hasAllStoresAccess;
var getSalarySystemSetting = function (salarySystemSettings, tableName, key) {
    return salarySystemSettings.find(function (salarySystemSetting) {
        return salarySystemSetting.tableName === tableName && salarySystemSetting.key === key;
    });
};
exports.getSalarySystemSetting = getSalarySystemSetting;
var getTargetSales = function (aggregateSales, salesType) {
    if (salesType === graphql_1.SalesType.SHOKEI) {
        return aggregateSales.provisionalStoreSales;
    }
    else if (salesType === graphql_1.SalesType.SOURIAGE) {
        return aggregateSales.totalSales;
    }
    else {
        return 0;
    }
};
exports.getTargetSales = getTargetSales;
var getSalesRange = function (data) {
    if (data.length === 0) {
        return 0;
    }
    // 末尾データの売上範囲と同等にする
    return data[data.length - 1].upperLimit - data[data.length - 1].lowerLimit;
};
exports.getSalesRange = getSalesRange;
var getAmountRange = function (data) {
    if (data.length <= 1) {
        return 0;
    }
    // 末尾データとその1つ前のデータの金額の差分
    return data[data.length - 1].amount - data[data.length - 2].amount;
};
exports.getAmountRange = getAmountRange;
//# sourceMappingURL=index.js.map